import User from "@/modules/user/user.js";

export const refreshSetup = ({ commit }) => {
    return new Promise((resolve, reject) => {
        User.fetchSetup()
                .then(response => {
                    commit('SETUP', response.data);
                    resolve(response.data)
                })
                .catch(e => {
                    console.log(e)
                    reject(e);
                })
         
    });
}